import { useCallback, useMemo, useState } from "react";

export const usePagination = <Item>(
  items: readonly Item[],
  pageSize: number,
) => {
  const [requestedPage, setRequestedPage] = useState(1);
  const totalPages = Math.ceil(items.length / pageSize);
  const currentPage = Math.min(requestedPage, Math.max(totalPages, 1));

  const paginatedItems = useMemo(() => {
    const startIndex = (currentPage - 1) * pageSize;
    return items.slice(startIndex, startIndex + pageSize);
  }, [currentPage, items, pageSize]);

  const setCurrentPage = useCallback(
    (page: number) => {
      setRequestedPage(Math.min(Math.max(page, 1), Math.max(totalPages, 1)));
    },
    [totalPages],
  );
  const resetPage = useCallback(() => setRequestedPage(1), []);

  return {
    currentPage,
    paginatedItems,
    resetPage,
    setCurrentPage,
    totalPages,
  };
};
